export const messages = {
  "en-gbr": {
    dashboard: {
      greeting: "Good morning",
      congratulations: "Congratulations!",
      closeToReward: "You're close to a reward",
      xpLabel: "XP",
      subjectsTitle: "Subjects",
      viewAll: "View All",
      createQuizCta: "Create your own quiz, invite friends to play!",
      leaderboardTitle: "Leaderboard",
      liveSessionsTitle: "Live/Recorded Sessions",
      seeAll: "See all",
      watch: "Watch",
      subjectGoTo: "Go to quizzes filtered by {subject}",
      subjectFilter: "Filter by {subject}",
      table: {
        rank: "Rank",
        name: "Name",
        email: "Email",
        course: "Course",
        points: "Points",
      },
      liveSessionItems: {
        designThinking: "QnA: Design Thinking From Scratch",
        aiUiUx: "QnA: Application of AI in UI/UX Design",
        date: "July 20, 2024",
        time: "08:00 - 09:00 AM",
      },
      notificationsAria: "Notifications",
    },
    ranking: {
      title: "Ranking",
      tabs: {
        weekly: "Weekly",
        allTime: "All Time",
      },
      banner: {
        weeklyChampion: "Defending champion this week!",
        allTime: "Showing all-time data...",
      },
      bottomSheet: {
        title: "List of Winners",
        students: "{count} students",
      },
      filters: {
        allSubjects: "All Subjects",
        allLevels: "All Levels",
      },
      actions: {
        find: "Find",
      },
      list: {
        loading: "Loading...",
        empty: "No results",
      },
      gradeFallback: "Grade {number}",
    },
    quizGenerate: {
      subjectStep: {
        title: "Select Subject",
        subtitle: "Choose a subject to get started.",
        searchPlaceholder: "Search Subject",
        fallbackDescription: "Personal class with a tutor",
      },
      setupStep: {
        titleLabel: "Quiz Title",
        titlePlaceholder: "Enter quiz title",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Describe the quiz",
        timerLabel: "Timer",
        timerMin: "1m",
        timerMax: "60m",
        chapterLabel: "Chapter",
        gradeLabel: "Grade",
        totalQuestionLabel: "Total Question",
      },
      drawer: {
        chapterTitle: "Select Chapter",
        chapterPlaceholder: "All Chapters",
        gradeTitle: "Select Grade",
        gradePlaceholder: "Select Grade",
        confirmPinInputTitle: "Add Pin When Review",
        optionTrue: "Yes",
        optionFalse: "No",
      },
      coverStep: {
        title: "Quiz Cover Image",
        uploadButton: "Find From Your Device",
      },
      privacyStep: {
        title: "Who can view this quiz?",
        subtitle: 'Before you hit "Create", choose the quiz privacy type:',
        privateTitle: "Private",
        privateBadge: "Default",
        privateDescription: "Only you can view and use this quiz.",
        publicTitle: "Public",
        publicBadge: "Subscribers only",
        publicDescription:
          "Other users will be able to access and use your quiz.",
      },
      modal: {
        title: "Want to share your quiz with others?",
        descriptionBefore:
          "To publish your quiz and make it accessible to others, please ",
        descriptionHighlight: "subscribe",
        descriptionAfter: "first.",
        subscribeNow: "Subscribe Now",
        maybeLater: "Maybe Later",
      },
      buttons: {
        back: "Back",
        next: "Next",
        create: "Create",
      },
      snackbar: {
        selectSubject: "Please select a subject first",
        titleRequired: "Quiz title is required",
        gradeRequired: "Please select a grade",
        totalQuestionRequired: "Total question is required",
        pinRequired: "Please provide a 4-digit PIN to enable review protection",
        privacyRequired: "Please select privacy",
        createSuccess: "Quiz {subject} created!",
        createFailed: "Failed to create quiz",
        createFailedWithReason: "Failed to create quiz: {reason}",
      },
      timer: {
        option: "{count} minute | {count} minutes",
      },
      gradeFallback: "Grade {number}",
    },
    bottomBar: {
      home: "Home",
      quiz: "Quiz",
      ranking: "Ranking",
      profile: "Profile",
    },
    settings: {
      title: "Setting",
      user: {
        namePlaceholder: "User name",
        emailPlaceholder: "Email",
        level: "Level Study",
      },
      menu: {
        editProfile: "Edit Profile",
        changePassword: "Change Password",
        subscribe: "Subscribe",
      },
      preferences: {
        title: "Preferences",
        paymentMethod: "Payment Method",
        saved: "Saved",
        reviewBookmarks: "Bookmarks",
        archived: "Archived",
        notifications: "Notifications",
        languages: "Languages",
      },
      resources: {
        title: "Resources",
        helpSupport: "Help & Support",
        about: "About",
      },
    },
    tutorBuilder: {
      back: "Back",
      mobile: {
        title: "Tutor Quiz Builder",
        description:
          "This feature is only available on web view. Please use a desktop browser.",
        back: "Back",
      },
      step1: {
        label: "Step 1",
        title: "Create Quiz",
        description:
          "This is the form for creating a quiz. Please fill up the form and submit to proceed.",
        loginRequired:
          "Please login to continue. Tutor quiz creation requires an authenticated user ID.",
        loading: "Loading subjects, grades, and categories...",
        fields: {
          titleLabel: "Enter Your Question Title",
          titlePlaceholder: "Enter Your Question Title",
          subjectLabel: "Please Select Subject",
          subjectPlaceholder: "Please Select Subject",
          gradeLabel: "Please Select Grade",
          gradePlaceholder: "Please Select Grade",
        },
        buttons: {
          reset: "Reset",
          submit: "Submit",
        },
        activeGuid: "Active Quiz GUID:",
      },
      step2: {
        label: "Step 2",
        title: "Create Questions",
        description:
          "Complete the quiz creation form and click submit to move forward.",
        locked: "Complete the quiz shell first to unlock the question builder.",
        questionLabel: "Question",
        questionPlaceholder: "Enter Your Question",
        choicePlaceholder: "Enter answer option",
        choiceOptionalPlaceholder: "Optional",
        dropFileTitle: "Upload File",
        dropFileInstruction: "Choose a file or drag & drop it here",
        dropFileHint: "PDF formats, up to 10 MB",
        browseFile: "Browse File",
        noFile: "No file selected",
        removeFile: "Remove",
        chooseAnswer: "Choose The Answer",
        allowMultiple: "Allow multiple answers",
        backToList: "Back To List",
        newQuestion: "New Question",
        helper: "To complete this set of question",
      },
      step3: {
        label: "Step 3",
        title: "Review & Generate",
        description:
          "Select questions you want to include and submit to generate the tutor quiz.",
        empty: "No questions yet. Use the Create Questions form above to start building your bank.",
        selectAll: "Select All",
        unselectAll: "Unselect All",
        questionNumber: "Question {number}",
        selectionCount: "Selected: {count} question(s)",
        generatedGuid: "Generated GUID:",
        ready: "Ready to generate once you hit submit.",
        fields: {
          quizTitleLabel: "Quiz Title",
          quizTitlePlaceholder: "Favorite Fraction Question Set",
          durationLabel: "Duration (minutes)",
          durationPlaceholder: "20",
          descriptionLabel: "Description",
          descriptionPlaceholder: "Selected questions from my bank",
          pointsLabel: "Points",
          pointsPlaceholder: "120",
          categoryLabel: "Quiz Category",
          publicTitle: "Public Quiz",
          publicDescription: "Allow other students to attempt this quiz.",
          reviewTitle: "Require Review PIN",
          reviewDescription: "Use a PIN before showing quiz review.",
          reviewPinLabel: "Review PIN",
          reviewPinPlaceholder: "1234",
          subjectGrade: "Subject ID: {subject} | Grade ID: {grade}",
          submit: "Submit",
        },
      },
      modal: {
        status: "Success",
        title: "Tutor quiz created successfully",
        description: "Go back to home or create another quiz?",
        backHome: "Back to Home",
        createAgain: "Create Another Quiz",
      },
      snackbar: {
        loginRequired: "Please login first.",
        titleRequired: "Quiz title is required.",
        subjectRequired: "Please select a subject first.",
        gradeRequired: "Please select a grade first.",
        categoryRequired: "Please select a quiz category.",
        reviewPinInvalid: "Review PIN must be 4 digits.",
        createSuccess: "Quiz created. Continue adding questions.",
        createFailed: "Failed to create tutor quiz.",
        needQuizFirst: "Create a quiz first.",
        questionRequired: "Main question cannot be empty.",
        correctAnswerRequired: "Correct answer must have text.",
        addQuestionSuccess: "Question added successfully.",
        addQuestionFailed: "Failed to add question.",
        missingQuestionId: "Question saved but ID not found.",
        minSelection: "Select at least one question.",
        generateTitleRequired: "Generated quiz title is required.",
        generateReviewPinInvalid: "Review PIN must be 4 digits.",
        invalidSubjectGrade: "Subject or Grade is invalid.",
        generateSuccess: "Quiz generated successfully.",
        generateFailed: "Failed to generate quiz from selection.",
        dropdownFailed: "Failed to load quiz reference data.",
      },
    },
  },
  "ms-my": {
    dashboard: {
      greeting: "Selamat pagi",
      congratulations: "Tahniah!",
      closeToReward: "Anda hampir mendapatkan ganjaran",
      xpLabel: "XP",
      subjectsTitle: "Subjek",
      viewAll: "Lihat semua",
      createQuizCta: "Cipta kuiz anda sendiri, jemput rakan untuk bermain!",
      leaderboardTitle: "Papan Skor",
      liveSessionsTitle: "Sesi Langsung/Rakaman",
      seeAll: "Lihat semua",
      watch: "Tonton",
      subjectGoTo: "Pergi ke kuiz bagi {subject}",
      subjectFilter: "Tapis mengikut {subject}",
      table: {
        rank: "Kedudukan",
        name: "Nama",
        email: "Emel",
        course: "Kursus",
        points: "Mata",
      },
      liveSessionItems: {
        designThinking: "S&J: Pemikiran Reka Bentuk Dari Asas",
        aiUiUx: "S&J: Aplikasi AI dalam Reka Bentuk UI/UX",
        date: "20 Julai 2024",
        time: "08:00 - 09:00 Pagi",
      },
      notificationsAria: "Notifikasi",
    },
    ranking: {
      title: "Kedudukan",
      tabs: {
        weekly: "Mingguan",
        allTime: "Sepanjang masa",
      },
      banner: {
        weeklyChampion: "Juara bertahan minggu ini!",
        allTime: "Memaparkan data sepanjang masa...",
      },
      bottomSheet: {
        title: "Senarai Pemenang",
        students: "{count} pelajar",
      },
      filters: {
        allSubjects: "Semua Subjek",
        allLevels: "Semua Tahap",
      },
      actions: {
        find: "Cari",
      },
      list: {
        loading: "Sedang dimuat...",
        empty: "Tiada keputusan",
      },
      gradeFallback: "Gred {number}",
    },
    quizGenerate: {
      subjectStep: {
        title: "Pilih Subjek",
        subtitle: "Pilih subjek untuk bermula.",
        searchPlaceholder: "Cari Subjek",
        fallbackDescription: "Kelas peribadi bersama tutor",
      },
      setupStep: {
        titleLabel: "Tajuk Kuiz",
        titlePlaceholder: "Masukkan tajuk kuiz",
        descriptionLabel: "Deskripsi",
        descriptionPlaceholder: "Terangkan tentang kuiz",
        timerLabel: "Pemasa",
        timerMin: "1m",
        timerMax: "60m",
        chapterLabel: "Bab",
        gradeLabel: "Gred",
        totalQuestionLabel: "Jumlah Soalan",
      },
      drawer: {
        chapterTitle: "Pilih Bab",
        chapterPlaceholder: "Semua Bab",
        gradeTitle: "Pilih Gred",
        gradePlaceholder: "Pilih Gred",
        confirmPinInputTitle: "Konfirmasi Pin Input Saat Review",
        optionTrue: "Iya",
        optionFalse: "Tidak",
      },
      coverStep: {
        title: "Imej Kulit Kuiz",
        uploadButton: "Cari dari peranti anda",
      },
      privacyStep: {
        title: "Siapa yang boleh melihat kuiz ini?",
        subtitle:
          'Sebelum anda menekan "Create", pilih jenis privasi kuiz anda:',
        privateTitle: "Peribadi",
        privateBadge: "Lalai",
        privateDescription:
          "Kuiz ini hanya boleh dilihat dan digunakan oleh anda.",
        publicTitle: "Umum",
        publicBadge: "Untuk pelanggan sahaja",
        publicDescription:
          "Pengguna lain akan boleh mengakses dan menggunakan kuiz anda.",
      },
      modal: {
        title: "Mahukan orang lain berkongsi kuiz anda?",
        descriptionBefore:
          "Untuk menerbitkan kuiz anda dan membolehkan orang lain mengaksesnya, sila ",
        descriptionHighlight: "langgan",
        descriptionAfter: "terlebih dahulu.",
        subscribeNow: "Langgan Sekarang",
        maybeLater: "Nanti Dulu",
      },
      buttons: {
        back: "Kembali",
        next: "Seterusnya",
        create: "Cipta",
      },
      snackbar: {
        selectSubject: "Sila pilih subjek terlebih dahulu",
        titleRequired: "Tajuk kuiz diperlukan",
        gradeRequired: "Sila pilih gred",
        totalQuestionRequired: "Jumlah soalan diperlukan",
        pinRequired: "Sila isi PIN 4 digit untuk mengaktifkan perlindungan ulasan",
        privacyRequired: "Sila pilih privasi",
        createSuccess: "Kuiz {subject} berjaya dicipta!",
        createFailed: "Gagal mencipta kuiz",
        createFailedWithReason: "Gagal mencipta kuiz: {reason}",
      },
      timer: {
        option: "{count} minit",
      },
      gradeFallback: "Gred {number}",
    },
    bottomBar: {
      home: "Utama",
      quiz: "Kuiz",
      ranking: "Kedudukan",
      profile: "Profil",
    },
    settings: {
      title: "Tetapan",
      user: {
        namePlaceholder: "Nama Pengguna",
        emailPlaceholder: "E-mel",
        level: "Tahap Pembelajaran",
      },
      menu: {
        editProfile: "Sunting Profil",
        changePassword: "Tukar Kata Laluan",
        subscribe: "Langganan",
      },
      preferences: {
        title: "Keutamaan",
        paymentMethod: "Kaedah Pembayaran",
        saved: "Disimpan",
        reviewBookmarks: "Penanda Buku",
        archived: "Diarkibkan",
        notifications: "Pemberitahuan",
        languages: "Bahasa",
      },
      resources: {
        title: "Sumber",
        helpSupport: "Bantuan & Sokongan",
        about: "Tentang",
      },
    },
    tutorBuilder: {
      back: "Kembali",
      mobile: {
        title: "Tutor Quiz Builder",
        description:
          "Ciri ini hanya tersedia pada paparan web. Sila gunakan pelayar desktop.",
        back: "Kembali",
      },
      step1: {
        label: "Langkah 1",
        title: "Cipta Kuiz",
        description:
          "Ini borang untuk mencipta kuiz. Sila isi dan hantar untuk meneruskan.",
        loginRequired:
          "Sila log masuk untuk meneruskan. Penciptaan kuiz tutor memerlukan ID pengguna disahkan.",
        loading: "Memuat subjek, gred, dan kategori...",
        fields: {
          titleLabel: "Masukkan Tajuk Soalan",
          titlePlaceholder: "Masukkan Tajuk Soalan",
          subjectLabel: "Sila Pilih Subjek",
          subjectPlaceholder: "Sila Pilih Subjek",
          gradeLabel: "Sila Pilih Gred",
          gradePlaceholder: "Sila Pilih Gred",
        },
        buttons: {
          reset: "Tetap Semula",
          submit: "Hantar",
        },
        activeGuid: "GUID Kuiz Aktif:",
      },
      step2: {
        label: "Langkah 2",
        title: "Cipta Soalan",
        description:
          "Lengkapkan borang penciptaan kuiz dan klik hantar untuk bergerak ke hadapan.",
        locked:
          "Selesaikan shell kuiz dahulu untuk membuka pembina soalan.",
        questionLabel: "Soalan",
        questionPlaceholder: "Masukkan Soalan Anda",
        choicePlaceholder: "Masukkan pilihan jawapan",
        choiceOptionalPlaceholder: "Pilihan",
        dropFileTitle: "Muat Naik Fail",
        dropFileInstruction: "Pilih fail atau seret & lepaskan di sini",
        dropFileHint: "Format PDF, sehingga 10 MB",
        browseFile: "Cari Fail",
        noFile: "Tiada fail dipilih",
        removeFile: "Buang",
        chooseAnswer: "Pilih Jawapan",
        allowMultiple: "Benarkan berbilang jawapan",
        backToList: "Kembali ke Senarai",
        newQuestion: "Soalan Baharu",
        helper: "Lengkapkan set soalan ini",
      },
      step3: {
        label: "Langkah 3",
        title: "Tinjau & Jana",
        description:
          "Pilih soalan yang ingin disertakan dan hantar untuk jana kuiz tutor.",
        empty:
          "Tiada soalan lagi. Gunakan borang Cipta Soalan di atas untuk mula membina bank.",
        selectAll: "Pilih Semua",
        unselectAll: "Nyahpilih Semua",
        questionNumber: "Soalan {number}",
        selectionCount: "Dipilih: {count} soalan",
        generatedGuid: "GUID Dijana:",
        ready: "Sedia dijana apabila anda tekan hantar.",
        fields: {
          quizTitleLabel: "Tajuk Kuiz",
          quizTitlePlaceholder: "Set Soalan Pecahan Kegemaran",
          durationLabel: "Tempoh (minit)",
          durationPlaceholder: "20",
          descriptionLabel: "Deskripsi",
          descriptionPlaceholder: "Soalan pilihan daripada bank peribadi",
          pointsLabel: "Mata",
          pointsPlaceholder: "120",
          categoryLabel: "Kategori Kuiz",
          publicTitle: "Kuiz Umum",
          publicDescription: "Benarkan pelajar lain mencuba kuiz ini.",
          reviewTitle: "Perlukan PIN Semakan",
          reviewDescription: "Guna PIN sebelum memaparkan semakan kuiz.",
          reviewPinLabel: "PIN Semakan",
          reviewPinPlaceholder: "1234",
          subjectGrade: "ID Subjek: {subject} | ID Gred: {grade}",
          submit: "Hantar",
        },
      },
      modal: {
        status: "Berjaya",
        title: "Kuiz tutor berjaya dibuat",
        description: "Mahukah kembali ke beranda atau terus cipta kuiz baharu?",
        backHome: "Kembali ke Beranda",
        createAgain: "Cipta Kuiz Lagi",
      },
      snackbar: {
        loginRequired: "Sila log masuk dahulu.",
        titleRequired: "Tajuk kuiz diperlukan.",
        subjectRequired: "Sila pilih subjek terlebih dahulu.",
        gradeRequired: "Sila pilih gred terlebih dahulu.",
        categoryRequired: "Sila pilih kategori kuiz.",
        reviewPinInvalid: "PIN semakan mesti 4 digit.",
        createSuccess: "Kuiz berjaya dicipta. Teruskan tambah soalan.",
        createFailed: "Gagal mencipta kuiz tutor.",
        needQuizFirst: "Cipta kuiz terlebih dahulu.",
        questionRequired: "Soalan utama tidak boleh kosong.",
        correctAnswerRequired: "Jawapan betul mesti mempunyai teks.",
        addQuestionSuccess: "Soalan berjaya ditambahkan.",
        addQuestionFailed: "Gagal menambah soalan.",
        missingQuestionId: "Soalan disimpan tetapi ID tiada.",
        minSelection: "Pilih sekurang-kurangnya satu soalan.",
        generateTitleRequired: "Tajuk kuiz hasil jana diperlukan.",
        generateReviewPinInvalid: "PIN semakan mesti 4 digit.",
        invalidSubjectGrade: "Subjek atau Gred tidak sah.",
        generateSuccess: "Kuiz berjaya dijana.",
        generateFailed: "Gagal menjana kuiz daripada pilihan.",
        dropdownFailed: "Gagal memuat data rujukan kuiz.",
      },
    },
  },
};
